<template>
  <div class="home-product-area" ref="homeProductArea">
    <div class="title-container">
      <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
        <img loading="lazy" class="home-product-area-title animate__animated " v-if="offsetTop < 650"
          src="@/assets/img/home/productCenterText1.png" alt="">
      </Transition>
    </div>

    <div class="home-product-area-left" @mouseenter="isLeftEnter = true" @mouseleave="isLeftEnter = false">
      <img loading="lazy" class="home-product-area-bg" src="@/assets/img/home/productCenterImg1.png" alt="">
      <transition-group enter-active-class="animate__animated animate__fadeIn animate__delay-0s"
        leave-active-class="animate__animated animate__fadeOut ">
        <div v-if="!isLeftEnter" key="container" class="container">
          <img loading="lazy" class="home-product-area-icon" src="@/assets/img/home/productCenterImg3.png" alt="">
          <div class="home-product-area-type">主要研究领域</div>
        </div>
        <div v-else key="upper-type" class="home-product-area-upper-type">主要研究领域</div>
        <div v-if="isLeftEnter" key="list-container" class="home-product-area-details">
          <div v-for="item in domainList" :key="item.id" style="cursor: auto;">
            <div> {{ item.productName }}</div>
          </div>
        </div>
        <el-button v-if="isLeftEnter" type="primary" key="btn" plain round size="medium"
          @click="$router.push('/productCenter')">查看更多</el-button>
      </transition-group>

    </div>
    <div class="home-product-area-right" @mouseenter="isRightEnter = true" @mouseleave="isRightEnter = false">
      <img loading="lazy" class="home-product-area-bg" src="@/assets/img/home/productCenterImg2.png" alt="">
      <transition-group enter-active-class="animate__animated animate__fadeIn animate__delay-0s"
        leave-active-class="animate__animated animate__fadeOut ">
        <div v-if="!isRightEnter" key="container" class="container">
          <img loading="lazy" class="home-product-area-icon icon2" src="@/assets/img/home/productCenterImg4.png" alt="">
          <div class="home-product-area-type">主要产品</div>
        </div>
        <div v-else key="upper-type" class="home-product-area-upper-type">主要产品</div>
        <div v-if="isRightEnter" key="list-container" class="home-product-area-details">
          <div v-for="item in productList" :key="item.id"
            @click="$router.push({ name: `/productDetails`, params: item })">
            {{ item.productName }}
          </div>
        </div>
        <el-button v-if="isRightEnter" type="primary" key="btn" plain round size="medium"
          @click="$router.push('/productCenter')">查看更多</el-button>
      </transition-group>
      <div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {
      domainList: [],
      productList: [],
      isLeftEnter: false,
      isRightEnter: false,
    }
  },
  created() {
    this.getProductData()
  },
  mounted() {

  },
  methods: {
    getProductData() {
      this.$apis.product_center_list().then(res => {
        this.domainList = res.data.filter(item => item.category == '主要研究领域').slice(0, 6)
        this.productList = res.data.filter(item => item.category == '主要产品').slice(0, 6)
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.home-product-area {
  display: grid;
  justify-content: center;
  grid-template-rows: 108px 860px;
  grid-template-columns: repeat(2, 960px);
  font-family: FZLanTingHei-R-GBK;
  color: #FFFFFF;

  .title-container {
    width: 100%;
    height: 100%;
    background: #092948;
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    align-items: center;
    justify-content: center;

    .home-product-area-title {
      width: 44rem;
      height: 5.3125rem;
    }
  }


  .home-product-area-left,
  .home-product-area-right {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    .home-product-area-bg,
    .container {
      width: 960px;
      height: 860px;
      position: absolute;
      z-index: -1;
      left: 0;
      top: 0;
    }

    .container {
      z-index: 10;

      .home-product-area-icon {
        width: 282px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%);
      }

      .icon2 {
        width: 226px;
      }

      .home-product-area-type {
        width: 100%;
        letter-spacing: 4px;
        margin-top: 40px;
        font-weight: 400;
        font-size: 30px;
        position: absolute;
        top: calc(50% + 120px);
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }





    .home-product-area-upper-type {
      // display: none;
      letter-spacing: 4px;
      position: absolute;
      font-weight: 600;
      left: 160px;
      top: 80px;
      font-size: 30px;
    }

    .home-product-area-details {
      display: grid;
      gap: 1.25rem;
      font-size: 1.5rem;
      width: 960px;
      color: #FFFFFF;

      div {
        height: 3.1875rem;
        line-height: 3.1875rem;
        cursor: pointer;
      }

      div:hover {
        background: #1a9ada;
      }

    }

    .el-button {
      display: none;
      background: transparent;
      color: #FFFFFF;
      border-color: #FFFFFF;
      position: absolute;
      right: 1.25rem;
      bottom: 1.25rem;
    }

    &:hover .el-button {
      display: block;
    }

    .el-button:hover {
      color: #0096FF;
      border-color: #0096FF;
    }
  }
}
</style>